<header class="rpt-hdr noprint">
  <div class="rpt-hdr__inner">
    <a class="rpt-brand" routerLink="/">
      <img src="assets/adventum-logo.svg" alt="Adventum Calculators" class="rpt-brand__logo">
    </a>
    <div class="rpt-crumb">
      <span>{{ crumbLabel }}</span>
      <span>·</span>
      <strong>{{ crumbSuffix }}</strong>
    </div>
    <div class="rpt-hdr__actions noprint">
      <button *ngIf="!loadingDownload" class="rpt-btn rpt-btn--download" (click)="download.emit()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
        <span class="rpt-btn--download__text">Download PDF</span>
      </button>
      <button *ngIf="loadingDownload" class="rpt-btn"><i class="fa fa-spin fa-spinner"></i></button>
      <button class="rpt-btn rpt-btn--primary" (click)="recalculate.emit()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
        <span>Recalculate</span>
      </button>
    </div>
  </div>
</header>
